import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "fa-stack"
};
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Icon',
    props: {
        name: {},
        iconStyle: { default: 'regular' },
        spin: { type: Boolean, default: false },
        animate: {},
        stack: {},
        size: {}
    },
    setup(__props) {
        const props = __props;
        const classes = computed(() => {
            const cs = [
                'icon',
                styleClass(),
                iconClass()
            ];
            if (props.spin) {
                cs.push('fa-spin');
            }
            if (props.animate) {
                cs.push(`fa-${props.animate}`);
            }
            if (props.stack) {
                cs.push(`fa-stack-1x`);
            }
            if (props.size) {
                if (props.stack) {
                    // size of the stack
                    cs.push(`fa-${props.size}`);
                }
                else {
                    // size of the stacked icon
                    cs.push(`fa-stack-${props.size}`);
                }
            }
            return cs;
        });
        function styleClass() {
            return `fa-${(props.iconStyle)}`;
        }
        function iconClass() {
            return props.name.indexOf('fa-') === 0
                ? props.name
                : 'fa-' + resolveAlias(props.name);
        }
        function resolveAlias(name) {
            switch (name) {
                // alerts
                case 'info':
                    return 'info-circle';
                case 'success':
                    return 'check-circle';
                case 'warning':
                    return 'exclamation-triangle';
                case 'error':
                    return 'times-circle';
                // common
                case 'view':
                    return 'eye';
                case 'delete':
                    return 'trash-alt';
                case 'create':
                case 'add':
                    return 'plus';
                case 'edit':
                    return 'pencil';
                case 'logs':
                    return 'clipboard-list';
                case 'config':
                    return 'gears';
                case 'close':
                    return 'times';
                case 'cancel':
                    return 'ban';
                case 'back':
                    return 'arrow-left';
                case 'login':
                    return 'key';
                case 'true':
                    return 'check-square';
                case 'false':
                    return 'square';
                case 'collapse':
                    return 'compress';
                case 'monitor':
                    return 'monitor-heart-rate';
                case 'help':
                    return 'question-circle';
                case 'import':
                    return 'upload';
                case 'reporting':
                    return 'wave-pulse';
                // operations
                case 'event':
                    return 'podcast';
                case 'task':
                    return 'tasks';
                case 'action':
                    return 'function';
                // shop
                case 'catalog':
                    // return 'cabinet-filing';
                    // return 'book-open';
                    return 'book';
                // return 'books';
                case 'orders':
                case 'cart':
                    return 'shopping-cart';
                case 'delivery':
                case 'deliveries':
                    // return 'truck-loading';
                    return 'truck';
                case 'watchlist':
                case 'watch-list':
                    return 'clipboard-list';
            }
            return name;
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon", true);
            return (!__props.stack || __props.stack.length === 0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(classes.value)
                }, null, 2))
                : (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _createElementVNode("span", {
                        class: _normalizeClass(classes.value)
                    }, null, 2),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stack, (icon) => {
                        return (_openBlock(), _createBlock(_component_icon, {
                            name: icon.name,
                            size: icon.size
                        }, null, 8, ["name", "size"]));
                    }), 256))
                ]));
        };
    }
});
